<template>
  <el-container
    ><div class="error-container">
      <img src="~/assets/pics/empty.png" alt="" />
      <div class="error-info">
        <div class="error-info">
          {{
            Object.getOwnPropertyNames(languages).length > 1
              ? languages.errors[errorType]
              : localLangData.errors[errorType]
          }}
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import localLanguageJson from 'config/localLanguage.json';
import { ubtRegister, ubtSendTrace } from 'utils/ubt';

export default {
  data() {
    return {
      localLangData: {},
      pvId: '',
    };
  },
  computed: {
    ...mapState(['languages', 'errorType']),
  },
  created() {
    this.seterrorStatus({ status: true });
    this.setShowFooter(false);
    const sysLanguage = window.clientLanguage;
    const lan = sysLanguage === 'zh-CN' || sysLanguage === undefined ? 'cn' : 'en';
    this.localLangData = localLanguageJson[lan];
    this.pvId = ubtRegister('Error');
    this.setPvId(this.pvId);
    ubtSendTrace(245277, 'error_page', this.errorType, '', '', '', this.pvId);
  },
  methods: {
    ...mapMutations(['seterrorStatus', 'setShowFooter', 'setPvId']),
  },
};
</script>

<style lang="scss" scoped>
.el-container {
  height: 100%;
  align-items: center;
  justify-content: center;
  .error-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 240px;
      height: 240px;
      margin-bottom: 10px;
    }
    span {
      cursor: pointer;
      color: #2e2eff;
      font-weight: bold;
      border-bottom: 1px solid #2e2eff;
    }
  }
}
</style>
